export * from "./blogApi";
export * from "./generated/types";
export * from "./hooks";
export * from "./queryClient";
import { Api as generatedApi } from "./generated";
import * as Blog from "./blogApi";
import * as Files from "./fileApi";

export const Api = { ...generatedApi, Blog, Files };
